import { ChevronDown } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import LaunchWaitlistForm from './launch-waitlist-form';

interface LaunchHeroSectionProps {
  heroEmail: string;
  setHeroEmail: (email: string) => void;
  heroSubmitted: boolean;
  heroLoading: boolean;
  onSubmitHero: () => void;
  scrollTo: (id: string) => void;
}

const LaunchHeroSection = ({
  heroEmail,
  setHeroEmail,
  heroSubmitted,
  heroLoading,
  onSubmitHero,
  scrollTo,
}: LaunchHeroSectionProps) => (
  <section className="relative min-h-screen flex flex-col justify-center px-4 sm:px-6 overflow-hidden">
    <div className="absolute inset-0 bg-gradient-to-b from-primary/5 via-transparent to-transparent" />
    <div className="absolute top-1/4 left-1/4 w-64 sm:w-96 h-64 sm:h-96 bg-primary/10 rounded-full blur-3xl" />
    <div className="absolute bottom-1/4 right-1/4 w-64 sm:w-96 h-64 sm:h-96 bg-primary/5 rounded-full blur-3xl" />
    <div className="relative max-w-4xl mx-auto text-center">
      <Badge
        variant="secondary"
        className="mb-6 sm:mb-8 px-3 sm:px-4 py-1 sm:py-1.5 text-xs sm:text-sm"
      >
        <span className="w-2 h-2 rounded-full bg-success animate-pulse mr-2 inline-block" />
        We're selecting 5 founding venues to shape the platform.
      </Badge>
      <h1 className="text-3xl sm:text-5xl lg:text-6xl font-display font-bold leading-tight mb-4 sm:mb-6">
        $150K Walks Out Your Door
        <br />
        <span className="gradient-text">Every Year.</span>
      </h1>
      <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto mb-8 sm:mb-10">
        Overpoured drinks. Untracked comps. VIPs treated like strangers. Your tools don't talk to
        each other — so the money disappears between them.
      </p>

      <div id="hero-form" className="max-w-lg mx-auto">
        <LaunchWaitlistForm
          email={heroEmail}
          setEmail={setHeroEmail}
          submitted={heroSubmitted}
          loading={heroLoading}
          onSubmit={onSubmitHero}
        />
      </div>
    </div>

    <button
      onClick={() => scrollTo('problem')}
      className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 text-muted-foreground/60 hover:text-primary transition-colors cursor-pointer"
      aria-label="Explore — scroll down"
    >
      <span className="text-[10px] uppercase tracking-widest font-medium">Explore</span>
      <ChevronDown size={20} className="animate-bounce" />
    </button>
  </section>
);

export default LaunchHeroSection;
